import React, { FC, useContext } from 'react'
import './UnknownError.scss'
import {
  ENVIRONMENT_VARIABLES,
  GENERIC_ERROR_MESSAGE_HEADING,
  GENERIC_ERROR_MESSAGE_LINE1,
  GENERIC_ERROR_MESSAGE_LINE2,
  LOGIN_APP_URL,
} from '~utils/constants'
import { EmptyState, Link } from '@connectcore/connect-components-react'
import { IUserContextType, UserContext } from '~utils/context/UserContext'

const UnknownError: FC = () => {
  const { env } = useContext(UserContext) as IUserContextType

  return (
    <div className="UnknownError d-flex flex-column w-70" data-testid="UnknownError">
      <EmptyState
        show={true}
        icon="alert-critical"
        iconSize="lg"
        text={GENERIC_ERROR_MESSAGE_HEADING}
        subtext={
          <>
            <div className="empty-state-subtext">{GENERIC_ERROR_MESSAGE_LINE1}</div>
            <div className="empty-state-subtext">{GENERIC_ERROR_MESSAGE_LINE2}</div>
          </>
        }
        style={{ height: 150 }}
        actionElement={
          env && <Link href={ENVIRONMENT_VARIABLES[env][LOGIN_APP_URL]}>Refresh application</Link>
        }
      />
    </div>
  )
}

export default UnknownError
